import { NavItem } from "../../layout";
import { useAppContext } from "context";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useStockTransferCounts } from "hooks";
import { activeMenuPath, buildMenu } from "./menuConfig";

// Rendered by BOTH shells — the classic sidebar and the modern shell's slide-out
// drawer — so a badge added here appears in both.
const NavMenu = () => {
  const { access, settings } = useAppContext();
  const { t } = useTranslation("nav");
  const { pathname } = useLocation();

  // One count per menu row, not a combined one: the two Stock Transfer screens are
  // separate on purpose, and a single number would not say WHICH of them to open.
  // See hooks/useStockTransferCounts.js.
  const { requests, shipments } = useStockTransferCounts();

  const groups = buildMenu(access, settings, t, {
    stockRequests: requests,
    stockShipments: shipments,
  });
  // Resolved across the WHOLE menu, not per group, so a path in one group can
  // never light a group that merely holds a shorter look-alike.
  const activePath = activeMenuPath(pathname, groups);

  return (
    <div>
      {groups.map((g) => (
        <NavItem
          key={g.key}
          title={g.title}
          path={g.path}
          icon={g.icon}
          child={g.children || []}
          activePath={activePath}
        />
      ))}
    </div>
  );
};

export default NavMenu;
